/* eslint-disable max-len */
import React, { useState } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'

import { TitleOne, TextBodyOne } from '../text'
import DetailServiceProduct from '../detail-service-product'
import icChevronRight from '../../static/images/service-product/ic-chevron-right.svg'
import serviceProductConstant from '../../constants/service-product'
import detailServiceProduct from '../../constants/detail-service-product'
import { Style } from './index.styles'

const {
  serviceProduct,
  serviceProductType: { HF }
} = serviceProductConstant
const { detail_service_product } = detailServiceProduct

const onPressItem = (props, item, state) => () => {
  const content = detail_service_product[props.content].find(
    detailServiceProduct => detailServiceProduct.id === item.id
  )
  state.setDetailServiceProduct(content)
  document.body.style.overflow = 'hidden'
  const headerElement = document.getElementById('header')
  const footerElement = document.getElementById('service-fixed')
  const whyMassageElement = document.getElementById('why-massage')
  const contentBody = document.getElementById('content-body')

  if (props.content === HF) {
    const mapFixElement = document.getElementById('map-fix')
    mapFixElement.style.display = 'none'

    const serviceMassageElement = document.getElementById('service-massage')
    serviceMassageElement.style.display = 'none'
  }

  headerElement.style.display = 'none'
  footerElement.style.display = 'none'
  whyMassageElement.style.display = 'none'
  contentBody.style.display = 'none'

  state.setShowDetailProduct(true)
}

const renderButton = (props, item, state) => (
  <div className="button-detail" onClick={onPressItem(props, item, state)}>
    <TextBodyOne className="text-button" display="block">
      Lihat Detail
    </TextBodyOne>
    <img src={icChevronRight} alt="halojasa/service-product-icon" />
  </div>
)

const renderProduct = (props, item, state) => (
  <div key={item.id} className="content-product">
    <img src={item.image} alt={`halojasa/${item.title}`} />
    <TextBodyOne className="title-product" display="block">
      {item.title}
    </TextBodyOne>
    <TextBodyOne className="subtitle-product" display="block">
      {item.subtitle}
    </TextBodyOne>
    {renderButton(props, item, state)}
  </div>
)

const renderProductList = (props, state) => (
  <div className="container-product">
    {serviceProduct[props.content].products.map(item =>
      renderProduct(props, item, state)
    )}
  </div>
)

const renderContainer = (props, state) => (
  <div
    className="content-service-product"
    style={{
      backgroundImage: `url(${serviceProduct[props.content].imageBackground})`
    }}
  >
    <TitleOne className="title-service-content" display="block">
      {serviceProduct[props.content].title}
    </TitleOne>
    {renderProductList(props, state)}
  </div>
)

const onCloseDetailServiceProduct = (props, state) => () => {
  document.body.style.overflow = 'scroll'
  const headerElement = document.getElementById('header')
  const footerElement = document.getElementById('service-fixed')
  const whyMassageElement = document.getElementById('why-massage')
  const contentBody = document.getElementById('content-body')

  if (props.content === HF) {
    const mapFixElement = document.getElementById('map-fix')
    mapFixElement.style.display = 'block'

    const serviceMassageElement = document.getElementById('service-massage')
    serviceMassageElement.style.display = 'block'
  }

  headerElement.style.display = 'block'
  footerElement.style.display = 'block'
  whyMassageElement.style.display = 'block'
  contentBody.style.display = 'block'

  state.setShowDetailProduct(false)
}

const useServiceProduct = () => {
  const [showDetailProduct, setShowDetailProduct] = useState(false)
  const [detailServiceProduct, setDetailServiceProduct] = useState({})

  return {
    showDetailProduct,
    setShowDetailProduct,
    detailServiceProduct,
    setDetailServiceProduct
  }
}

const ServiceProduct = props => {
  const state = useServiceProduct()

  return (
    <>
      <Style>
        <Grid>
          <Row>
            <Col sm={12} xs={12} lg={12} className="container-service-product">
              {renderContainer(props, state)}
            </Col>
          </Row>
        </Grid>
      </Style>
      {state.showDetailProduct && (
        <DetailServiceProduct
          onCloseDetailServiceProduct={onCloseDetailServiceProduct(
            props,
            state
          )}
          detailServiceProduct={state.detailServiceProduct}
        />
      )}
    </>
  )
}

export default ServiceProduct
